/* ==========================================================================
   custom-global.js — utilidades globales del tema (se carga en theme.liquid)
   ========================================================================== */

/* --------------------------------------------------------------------------
   Scroll reveal global. Cualquier elemento con [data-cr-reveal] aparece al
   entrar en viewport (añade .cr-in). Usa --cr-i para escalonar (stagger).
   Respeta prefers-reduced-motion: si el usuario lo pide, todo queda visible.
   -------------------------------------------------------------------------- */
(function () {
  function initReveal() {
    const els = document.querySelectorAll("[data-cr-reveal]");
    if (!els.length) return;

    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce || !("IntersectionObserver" in window)) {
      els.forEach((el) => el.classList.add("cr-in"));
      return;
    }

    const io = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("cr-in");
            obs.unobserve(entry.target);
          }
        });
      },
      { rootMargin: "0px 0px -10% 0px", threshold: 0.1 }
    );

    els.forEach((el) => io.observe(el));
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initReveal);
  } else {
    initReveal();
  }
})();

/* --------------------------------------------------------------------------
   Legacy: botón "scroll down" del hero antiguo. Se conserva pero blindado
   (antes reventaba con null cuando el hero cambiaba de ID). Hoy el hero nuevo
   maneja su propio scroll cue, así que esto es un no-op si no existe el viejo.
   -------------------------------------------------------------------------- */
(function () {
  const legacyHero = document.getElementById(
    "shopify-section-template--19638660628781__76339bdb-e1a9-45d1-8362-d3cbeac8a172"
  );
  if (!legacyHero || !legacyHero.nextElementSibling) return;

  const nextId = legacyHero.nextElementSibling.getAttribute("id");
  if (!nextId) return;

  const scrollButton = document.createElement("a");
  scrollButton.setAttribute("href", "#" + nextId);
  scrollButton.classList.add("scroll-button");
  scrollButton.innerHTML = "&#9662;";
  legacyHero.appendChild(scrollButton);
})();
